define('views/modules/template/edit/calendar/activity/activity-detail-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // events
    'services/events/calendar-events',
    // Views
    'views/modules/calendar/activity/detail/activity-detail-content',
    'views/parts/menu/menu-save-action',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // events
    CalendarEvents,
    // parent view
    VActivityDetails,
    // views
    VMenuSaveAction
) {

    var VTemplateActivityDetails = VActivityDetails.extend({

        initialize: function(opt) {
            VTemplateActivityDetails.__super__.initialize.call(this, opt);

            var view = _.extend(this.view, {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveClick,
                    radio: false,
                    tooltip: { container: this.regions.root, }
                })
            });

            if (this.group.isSupervisor())
            {
                view.menu.addMoreActions([{ icon: 'sl-icon-star', caption: 'Add current activity to my favorites', callback: this.onAddToFavoriteAction, context: this }]);
            }
        },

        /////////////
        // actions //
        /////////////

        onSaveClick: function() {
            CalendarEvents.onActivitySaveClick();
            this.submitFromSave = true;
            var model = this.model;
            model.set('name', model.get('sup_name'));
            this._onSuccess();
        },

    });

    return VTemplateActivityDetails;
});

